import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  module?: string;
  action?: 'view' | 'add' | 'edit' | 'delete';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  module,
  action = 'view'
}) => {
  const location = useLocation();
  const { user, hasPermission } = usePermissions();

  if (!user) {
    // Redirect to login page but save the attempted url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (module && !hasPermission(module, action)) {
    // Redirect to home page if user doesn't have required permissions
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 